import React from 'react';
import PropTypes from 'prop-types';
import TextField from './TextField';
import rolesHelper from 'helpers/roles';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

const AccountRoleTextField = (props) => {
    const { label, value, translate } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    const role = rolesHelper.getRole(value);

    if (!role) {
        return;
    }

    const translatedValue = translate(`resources.accounts.roles.${ role }`);

    return (
        <TextField
            label={ label }
            value={ translatedValue }
        />
    );
};

AccountRoleTextField.propTypes = {
    label: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.number,
    ]),
};

export default translate(AccountRoleTextField);



// WEBPACK FOOTER //
// ./src/components/show/AccountRoleTextField.js